define('appkit/router',['require','exports','module','backbone','underscore','./util/deparam'],function(require, exports, module){
  var Backbone = require('backbone');
  var _ = require('underscore');
  var deparam = require('./util/deparam');

  
  var NAMED_PARAM          = /:(\w+)/g;
  var SPLAT_PARAM          = /\*(\w+)/g;
  var OPTIONAL_PARAM       = /\((.*?)\)/g;

  var STATE_PROPERTY = 'state';

  var Router = Backbone.Router.extend({

    initialize: function() {
      this._routeNames = {};
    },

    route: function(route, name, callback) {
      var strRoute = route;

      if (!_.isRegExp(route)) {
        route = this._routeToRegExp(route);
      }

      if (_.isFunction(name)) {
        callback = name;
        name = '';
      }

      if (name) {
        this._registerName(name, strRoute);
      }

      if (!callback) callback = this[name];

      var router = this;
      Backbone.history.route(route, function(fragment) {
        router._onHistoryRoute(route, name, callback, fragment);
      });

      return this;
    },

    _onHistoryRoute: function(routeRegExp, routeName, callback, fragment) {
      var args         = this._extractParameters(routeRegExp, fragment),
          params       = this._resolveParams(routeName, args),
          ev           = null,
          executeRoute = null;

      executeRoute = _.partial(_.bind(_.once(this.executeRoute), this), routeName, params);

      ev = {
        preventDefault: false,
        fragment: fragment,
        execute: executeRoute
      };

      this.trigger('before:route:' + routeName, ev, params);
      this.trigger('before:route', routeName, ev, params);
      Backbone.history.trigger('before:route', this, routeName, ev, params);

      if (ev.preventDefault === true) {
        return;
      }

      if (this.executeCallback(callback, params, routeName) !== false) {
        executeRoute();
      }
    },

    executeRoute: function(routeName, params) {
      this.trigger('route:' + routeName, params);
      this.trigger('route', routeName, params);

      Backbone.history.trigger('route', this, routeName, params);
    },

    executeCallback: function(callback, params, name) {
      if (callback) return callback.call(this, params);
    },

    resolve: function(name, params) {
      return this.replaceRoute(this._routeNames[name] || '', params);
    },

    _resolveParams: function(name, args) {
      var route  = this._routeNames[name] || '',
          params = {},
          index  = 0;

      route
        .replace(NAMED_PARAM, function(match, valueField) {
          var value = args[index++];
          if (value != null) {
            params[valueField] = value;
          }
        })
        .replace(SPLAT_PARAM, function(match, valueField) {
          var value = args[index++];
          if (value != null) {
            if (valueField == STATE_PROPERTY) {
              _.extend(params, deparam(value));
            } else {
              params[valueField] = value;
            }
          }
        })

      return params;
    },

    _registerName: function(name, route) {
      this._routeNames[name] = route;
    },

    _updateRoute: function(routeName, params) {
      var routePath = this._routeNames[routeName] || routeName;
      var replacedRoute = this.replaceRoute(routePath, params);
      this.navigate(replacedRoute, { replace: true });
    },

    trimRoute: function(route) {
      // if replacedRoute ends in a slash then
      // we need to reformat it and remove it
      if (String(route == null ? '' : route).slice(-1) == '/') {
        return route.slice(0, -1);
      }
      return route;
    },

    replaceRoute: function(route, params) {
      params = params || {};

      if (params instanceof Backbone.Model) {
        params = params.toJSON();
      }

      params = _.clone(params);

      var replacedRoute = String(route || '')
          .replace(OPTIONAL_PARAM, function(match, content) {
            var matches = (content.match(NAMED_PARAM) || []).concat(content.match(SPLAT_PARAM) || []);

            var found = _.all(matches, function(match) {
              if (params[match.slice(1)] != null || match.slice(1) == STATE_PROPERTY) {
                return true;
              }
              return false;
            });

            if (!matches || matches.length == 0) {
              found = true;
            }

            return found ? content : '';
          })
          .replace(NAMED_PARAM, function(match, name) {
            var value = params[name];
            delete params[name];
            return value != null ? encodeURIComponent(value) : '';
          })
          .replace(SPLAT_PARAM, function(match, name) {
            if (name == STATE_PROPERTY) {

              return $.param(params);
            } else {
              // var value = params[name];
              // delete params[name];
              // return value != null ? encodeURIComponent(value) : '';
              return '';
            }
          });

      return this.trimRoute(replacedRoute);
    }

  });

  module.exports = Router;
});
